export const TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT =
  'TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT';

export const TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT =
  'TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT';

export const TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT =
  'TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT';

export const TELEGRAM_CHANNEL_CREATE_FETCH = 'TELEGRAM_CHANNEL_CREATE_FETCH';

export const TELEGRAM_CHANNEL_INFO_FETCH = 'TELEGRAM_CHANNEL_INFO_FETCH';

export const TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_INFO_FETCH_FAIL =
  'TELEGRAM_CHANNEL_INFO_FETCH_FAIL';

export const TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_CREATE_FETCH_FAIL =
  'TELEGRAM_CHANNEL_CREATE_FETCH_FAIL';

export const TELEGRAM_CHANNEL_LIST_FETCH = 'TELEGRAM_CHANNEL_LIST_FETCH';

export const TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_LIST_FETCH_FAIL =
  'TELEGRAM_CHANNEL_LIST_FETCH_FAIL';

export const TELEGRAM_CHANNEL_UPDATE_FETCH = 'TELEGRAM_CHANNEL_UPDATE_FETCH';

export const TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL =
  'TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL';

export const TELEGRAM_CHANNEL_DELETE_FETCH = 'TELEGRAM_CHANNEL_DELETE_FETCH';

export const TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_DELETE_FETCH_FAIL =
  'TELEGRAM_CHANNEL_DELETE_FETCH_FAIL';

export const TELEGRAM_CHANNEL_VIEW_FETCH = 'TELEGRAM_CHANNEL_VIEW_FETCH';

export const TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS =
  'TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS';

export const TELEGRAM_CHANNEL_VIEW_FETCH_FAIL =
  'TELEGRAM_CHANNEL_VIEW_FETCH_FAIL';
